import React from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";

import COLOR_THEMES, {COLORS} from "../../../colorThemes";
import SqftFeaturesPopupFeatureDropdown from "./sqftFeaturesPopupFeatureDropdown";
import SqftFeaturesPopupFeaturePrice from "./sqftFeaturesPopupFeaturePrice";
import SqftFeaturesPopupFeatureDeleteButton from "./sqftFeaturesPopupFeatureDeleteButton";
import SqftFeaturesPopupFeatureEyeball from "./sqftFeaturesPopupFeatureEyeball";
import FeatureName from "../../visComponents/featureName";
import {SQFT_FEATURES} from "../../sqft/constants";

const SqftFeaturesPopupFeature = (props) => {

  const { parentsList, parentsLists, setParentsLists, parentKey, sqftFeature, activeTheme, rebuildQuoteLists } = props;
  const {disabled, feature} = sqftFeature;

  const editButtonColor = disabled && feature
    ? COLOR_THEMES[activeTheme].primary
    : feature
      ? COLOR_THEMES[activeTheme].primary
      : COLORS.red
  const shouldDisplayEyeball = parentKey !== SQFT_FEATURES.slabs && sqftFeature.shouldShowEyeBall;
  const shouldDisplayEditButton = parentKey !== SQFT_FEATURES.edges && parentKey !== SQFT_FEATURES.slabs;

  return (
    <li className={"sqft-popup__feature bold" + (disabled ? " sqft-popup__feature--disabled" : "")
    + (feature ? " sqft-popup__feature--added" : "")} data-feature={!!feature}>
      { shouldDisplayEyeball
        ? <SqftFeaturesPopupFeatureEyeball editButtonColor={editButtonColor}
                                           sqftFeature={sqftFeature}/>
        : null
      }
      { shouldDisplayEditButton
        ? <SqftFeaturesPopupFeatureDropdown editButtonColor={editButtonColor}
                                            parentsList={parentsList}
                                            parentsLists={parentsLists}
                                            setParentsLists={setParentsLists}
                                            sqftFeature={sqftFeature}
                                            rebuildQuoteLists = { rebuildQuoteLists }/>
        : <div className="sqft-popup__feature-name">
          { feature ? <FeatureName feature={feature} maxLength={35}/> : null }
        </div>
      }
      <SqftFeaturesPopupFeaturePrice sqftFeature={sqftFeature} parentsList={parentsList} />
      {feature ? <SqftFeaturesPopupFeatureDeleteButton parentsList={parentsList}
                                                       parentsLists={parentsLists}
                                                       setParentsLists={setParentsLists}
                                                       sqftFeature={sqftFeature}/> : null}
    </li>
  )
};

SqftFeaturesPopupFeature.propTypes = {
  parentsList: PropTypes.object.isRequired,
  parentsLists: PropTypes.array.isRequired,
  setParentsLists: PropTypes.func.isRequired,
  parentKey: PropTypes.string.isRequired,
  sqftFeature: PropTypes.object.isRequired,
  rebuildQuoteLists: PropTypes.func.isRequired,
}

const mapStateToProps = (store) => {
  const {activeTheme} = store.serverState;
  return {
    activeTheme,
  };
};
const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(SqftFeaturesPopupFeature)
